// src/helpers/factories/settings/settingsRolesCardFactory.ts
var settingsRolesCardFactory = (roles, users) => {
  return Object.values(roles).map((role) => ({
    id: role.roleId,
    title: role.name,
    count: Object.values(users).filter(
      (user) => user.roleIds.includes(role.roleId)
    ).length,
    active: role.active,
    activeFilter: role.active ? 1 : 2,
    superAdmin: role.superAdmin
  }));
};

export { settingsRolesCardFactory };
